"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showFilePicker = showFilePicker;
exports.initFilePicker = initFilePicker;
const plugin_dialog_1 = require("@tauri-apps/plugin-dialog");
const TauriLoader_1 = require("./TauriLoader");
const Replay_1 = require("./Replay/Replay");
let viewer = null;
let cstrikePath = '';
function mapResourceRoot() {
    return cstrikePath;
}
function saveCstrikePath(path) {
    cstrikePath = path.replace(/[\\/]$/, '');
    localStorage.setItem('hlviewer.cstrikePath', cstrikePath);
    const input = document.getElementById('cstrike-folder');
    if (input)
        input.value = cstrikePath;
    const status = document.getElementById('cstrike-folder-status');
    if (status)
        status.textContent = cstrikePath ? `Using ${cstrikePath}/maps and ${cstrikePath} for WAD files.` : 'No local cstrike folder configured.';
    if (viewer)
        viewer.setLocalResourceRoot(cstrikePath);
    if (cstrikePath) {
        void populateList('map-list', `${cstrikePath}/maps`, ['.bsp'], loadMapByName);
    }
}
function chooseCstrikePath() {
    return __awaiter(this, void 0, void 0, function* () {
        const selected = yield (0, plugin_dialog_1.open)({ directory: true, multiple: false, defaultPath: cstrikePath || undefined });
        if (selected)
            saveCstrikePath(selected);
    });
}
let archiveRequest = 0;
let archiveSearchTimer;
let archiveMap = null;
let archiveReplays = [];
let selectedArchiveCategory = '';
function refreshPickerUi() {
    const returnBtn = document.getElementById('return-to-replay');
    if (returnBtn)
        returnBtn.disabled = !(viewer === null || viewer === void 0 ? void 0 : viewer.hasLoadedReplay);
}
function archiveUrl() {
    var _a;
    return ((_a = document.getElementById('archive-url')) === null || _a === void 0 ? void 0 : _a.value.replace(/\/$/, '')) || '';
}
function saveArchiveUrl(url) {
    const normalized = url.replace(/\/$/, '');
    localStorage.setItem('hlviewer.archiveUrl', normalized);
    const input = document.getElementById('archive-url');
    if (input)
        input.value = normalized;
}
function archiveDownloadUrl(runId) {
    return `${archiveUrl()}/v1/replays/${encodeURIComponent(runId)}/download`;
}
function formatArchiveTime(milliseconds) {
    const seconds = Math.floor(milliseconds / 1000);
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}.${String(milliseconds % 1000).padStart(3, '0')}`;
}
function archiveCategoryGroup(category) {
    if (/(?:^|\[)SR\b|\bSpeedrun\b/i.test(category))
        return 'speedrun';
    return 'bhop';
}
function compactArchiveCategory(category) {
    return category
        .replace(/^SR\s+/i, '')
        .replace(/\s*\(Low Gravity\)|\s+Low Gravity/ig, ' Low')
        .replace(/FPS\b/ig, '')
        .replace(/\s+/g, ' ')
        .trim();
}
function archiveCategoryFps(category) {
    var _a;
    return Number(((_a = category.match(/(\d+)\s*FPS/i)) === null || _a === void 0 ? void 0 : _a[1]) || Number.MAX_SAFE_INTEGER);
}
function archiveCategoryGravityOrder(category) {
    return /Low Gravity|\bLow\b/i.test(category) ? 1 : 0;
}
function fetchArchive(path) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(`${archiveUrl()}${path}`);
        if (!response.ok)
            throw new Error(`Archive returned HTTP ${response.status}`);
        return response.json();
    });
}
function loadArchiveReplay(mapName_1, replay_1) {
    return __awaiter(this, arguments, void 0, function* (mapName, replay, asComparison = false) {
        if (!viewer)
            return;
        try {
            const label = `${replay.player_name} · ${replay.category_name}`;
            if (asComparison && viewer.mapName) {
                if (viewer.mapName.toLowerCase() !== mapName.toLowerCase() &&
                    viewer.mapName.toLowerCase() !== `${mapName}.bsp`.toLowerCase()) {
                    throw new Error(`Loaded map (${viewer.mapName}) does not match ${mapName}`);
                }
                yield viewer.addComparisonReplayFromUrl(label, archiveDownloadUrl(replay.run_id));
                setStatus('Comparison replay added');
                return;
            }
            const localRoot = cstrikePath;
            if (!localRoot)
                throw new Error('Choose the local cstrike folder in Settings first');
            setStatus(`Loading ${mapName} and replay...`);
            viewer.setLocalResourceRoot(localRoot);
            yield viewer.loadMapFromPath(`${localRoot}/maps/${mapName}.bsp`);
            yield viewer.loadReplayFromUrl(archiveDownloadUrl(replay.run_id), `${replay.run_id}.rec`);
            refreshPickerUi();
            hideFilePicker();
            setStatus('');
        }
        catch (err) {
            console.error('loadArchiveReplay error:', err);
            setStatus(`Error: ${err}`);
        }
    });
}
function renderArchiveReplays() {
    if (!archiveMap)
        return;
    const title = document.getElementById('archive-map-title');
    const list = document.getElementById('archive-replay-list');
    if (!list)
        return;
    document.querySelectorAll('#archive-map-list .archive-map').forEach(item => {
        item.classList.toggle('is-active', item.dataset.mapName === (archiveMap === null || archiveMap === void 0 ? void 0 : archiveMap.map_name));
    });
    list.innerHTML = '';
    const rows = document.getElementById('archive-category-rows');
    if (rows) {
        rows.innerHTML = '';
        for (const [group, label] of [['bhop', 'Bhop'], ['speedrun', 'Speedrun']]) {
            const categories = [...new Set(archiveReplays
                    .filter(replay => archiveCategoryGroup(replay.category_name) === group)
                    .map(replay => replay.category_name))]
                .sort((a, b) => archiveCategoryGravityOrder(a) - archiveCategoryGravityOrder(b)
                || archiveCategoryFps(a) - archiveCategoryFps(b) || a.localeCompare(b));
            const row = document.createElement('div');
            row.className = `archive-category-row is-${group}`;
            const rowLabel = document.createElement('span');
            rowLabel.className = 'archive-category-label';
            rowLabel.textContent = label;
            const buttons = document.createElement('div');
            buttons.className = 'archive-category-buttons';
            for (const category of categories) {
                const button = document.createElement('button');
                button.type = 'button';
                button.className = `archive-category-button${selectedArchiveCategory === category ? ' is-active' : ''}`;
                button.textContent = compactArchiveCategory(category);
                button.addEventListener('click', () => {
                    selectedArchiveCategory = selectedArchiveCategory === category ? '' : category;
                    renderArchiveReplays();
                });
                buttons.appendChild(button);
            }
            row.append(rowLabel, buttons);
            rows.appendChild(row);
        }
    }
    const filteredReplays = selectedArchiveCategory
        ? archiveReplays.filter(replay => replay.category_name === selectedArchiveCategory)
        : archiveReplays;
    if (title)
        title.textContent = `${archiveMap.map_name} · ${filteredReplays.length} archived replay${filteredReplays.length === 1 ? '' : 's'}`;
    for (const replay of filteredReplays) {
        const item = document.createElement('div');
        item.className = 'fp-list-item archive-run';
        item.innerHTML = `<div style="display:flex; flex:1; flex-direction:column; gap:2px;"><span class="item-name"></span><span class="item-info"></span></div><button class="fp-selection-btn">Load</button><button class="fp-selection-btn compare">Compare</button>`;
        const labels = item.querySelectorAll('span');
        labels[0].textContent = `${replay.player_name} · ${compactArchiveCategory(replay.category_name)}`;
        labels[1].textContent = `${formatArchiveTime(replay.time_ms)} · ${replay.run_id}`;
        const buttons = item.querySelectorAll('button');
        buttons[0].addEventListener('click', () => loadArchiveReplay(archiveMap.map_name, replay));
        buttons[1].addEventListener('click', () => loadArchiveReplay(archiveMap.map_name, replay, true));
        list.appendChild(item);
    }
}
function showArchiveMap(map) {
    return __awaiter(this, void 0, void 0, function* () {
        const title = document.getElementById('archive-map-title');
        const list = document.getElementById('archive-replay-list');
        if (!list)
            return;
        archiveMap = map;
        selectedArchiveCategory = '';
        if (title)
            title.textContent = `${map.map_name} · loading archived replays...`;
        list.innerHTML = '';
        try {
            const replays = yield fetchArchive(`/v1/replays?map_name=${encodeURIComponent(map.map_name)}`);
            archiveReplays = replays.sort((a, b) => a.time_ms - b.time_ms || a.category_name.localeCompare(b.category_name) || a.run_id.localeCompare(b.run_id));
            renderArchiveReplays();
        }
        catch (err) {
            if (title)
                title.textContent = `Could not load ${map.map_name}`;
            setStatus(`Error: ${err}`);
        }
    });
}
function refreshArchive() {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const list = document.getElementById('archive-map-list');
        if (!list)
            return;
        list.innerHTML = '';
        const replayList = document.getElementById('archive-replay-list');
        if (replayList)
            replayList.innerHTML = '';
        const title = document.getElementById('archive-map-title');
        if (title)
            title.textContent = 'Choose a map';
        archiveMap = null;
        archiveReplays = [];
        selectedArchiveCategory = '';
        const categoryRows = document.getElementById('archive-category-rows');
        if (categoryRows)
            categoryRows.innerHTML = '';
        const request = ++archiveRequest;
        const query = ((_a = document.getElementById('archive-map-search')) === null || _a === void 0 ? void 0 : _a.value.trim()) || '';
        setStatus('Loading archive maps...');
        try {
            const maps = yield fetchArchive(`/v1/maps?query=${encodeURIComponent(query)}`);
            if (request !== archiveRequest)
                return;
            for (const map of maps) {
                const item = document.createElement('button');
                item.type = 'button';
                item.className = 'fp-list-item archive-map';
                item.dataset.mapName = map.map_name;
                item.textContent = `${map.map_name} (${map.replay_count})`;
                item.addEventListener('click', () => showArchiveMap(map));
                list.appendChild(item);
            }
            setStatus(maps.length ? 'Choose a map.' : 'No archived maps found.');
        }
        catch (err) {
            setStatus(`Could not load archive: ${err}`);
        }
    });
}
function setStatus(text) {
    const el = document.getElementById('status');
    if (el)
        el.textContent = text;
}
function showLogPanel() {
    const el = document.getElementById('log-panel');
    if (el)
        el.classList.remove('hidden');
}
function log(text, cls = '') {
    showLogPanel();
    const panel = document.getElementById('log-panel');
    if (!panel)
        return;
    const entry = document.createElement('div');
    entry.className = 'log-entry ' + cls;
    entry.textContent = text;
    panel.appendChild(entry);
    panel.scrollTop = panel.scrollHeight;
}
function clearLog() {
    const panel = document.getElementById('log-panel');
    if (panel)
        panel.innerHTML = '';
}
function showFilePicker() {
    const el = document.getElementById('file-picker');
    if (el)
        el.classList.remove('hidden');
    const backBtn = document.getElementById('back-btn');
    if (backBtn)
        backBtn.classList.remove('visible');
    const returnBtn = document.getElementById('return-to-replay');
    if (returnBtn) {
        returnBtn.hidden = false;
        refreshPickerUi();
    }
}
function hideFilePicker() {
    const el = document.getElementById('file-picker');
    if (el)
        el.classList.add('hidden');
    const backBtn = document.getElementById('back-btn');
    if (backBtn)
        backBtn.classList.add('visible');
}
function loadMapByName(mapName) {
    return __awaiter(this, void 0, void 0, function* () {
        const root = mapResourceRoot();
        if (!viewer || !root)
            return;
        clearLog();
        setStatus('Loading map...');
        try {
            const bspPath = `${root}/maps/${mapName}`;
            log(`Map: ${mapName}`, 'ok');
            viewer.setLocalResourceRoot(cstrikePath);
            yield viewer.loadMapFromPath(bspPath);
            log('Done!', 'ok');
            refreshPickerUi();
            setStatus('');
            hideFilePicker();
        }
        catch (err) {
            console.error('loadMapByName error:', err);
            log(`ERROR: ${err}`, 'error');
            setStatus(`Error: ${err}`);
        }
    });
}
function loadLocalReplays(asComparison) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!viewer)
            return;
        const selected = yield (0, plugin_dialog_1.open)({
            multiple: true,
            filters: [{ name: 'Replay files', extensions: ['rec', 'dem'] }],
        });
        if (!selected)
            return;
        const paths = Array.isArray(selected) ? selected : [selected];
        try {
            const replays = yield Promise.all(paths.map((path) => __awaiter(this, void 0, void 0, function* () {
                const { data } = Replay_1.Replay.parseCustomFile(yield (0, TauriLoader_1.readFileBytes)(path));
                return { path, data, name: data.header.name || path.split(/[\\/]/).pop() || 'Unknown player' };
            })));
            const mapName = replays[0].data.header.map;
            if (replays.some(replay => replay.data.header.map.toLowerCase() !== mapName.toLowerCase())) {
                throw new Error('All selected replays must use the same map');
            }
            if (asComparison && viewer.mapName) {
                const loadedMap = viewer.mapName.toLowerCase();
                if (loadedMap !== mapName.toLowerCase() && loadedMap !== `${mapName}.bsp`.toLowerCase()) {
                    throw new Error(`Loaded map (${viewer.mapName}) does not match ${mapName}`);
                }
                for (const replay of replays) {
                    const player = viewer.createReplayPlayer();
                    player.changeReplay({ data: replay.data });
                    viewer.addComparisonReplay(replay.name, player);
                }
                setStatus(`Added ${replays.length} comparison replay${replays.length === 1 ? '' : 's'}`);
                refreshPickerUi();
                return;
            }
            if (!cstrikePath)
                throw new Error('Choose the local cstrike folder in Settings first');
            setStatus(`Loading ${mapName} and replay...`);
            viewer.setLocalResourceRoot(cstrikePath);
            yield viewer.loadMapFromPath(`${cstrikePath}/maps/${mapName}.bsp`);
            yield viewer.loadFromPath(replays[0].path);
            for (const replay of replays.slice(1)) {
                const player = viewer.createReplayPlayer();
                player.changeReplay({ data: replay.data });
                viewer.addComparisonReplay(replay.name, player);
            }
            refreshPickerUi();
            hideFilePicker();
            setStatus('');
        }
        catch (err) {
            console.error('loadLocalReplays error:', err);
            setStatus(`Error: ${err}`);
        }
    });
}
function populateList(listId, dirPath, extensions, onClick) {
    return __awaiter(this, void 0, void 0, function* () {
        const list = document.getElementById(listId);
        if (!list)
            return;
        list.innerHTML = '';
        try {
            const files = yield (0, TauriLoader_1.listDirectory)(dirPath);
            const filtered = files.filter(f => {
                const lower = f.toLowerCase();
                return extensions.some(ext => lower.endsWith(ext));
            });
            if (filtered.length === 0) {
                list.innerHTML = `<div style="padding:20px; color:#666; text-align:center;">No files found</div>`;
                return;
            }
            filtered.forEach(name => {
                const item = document.createElement('div');
                item.className = 'fp-list-item';
                item.innerHTML = `<span class="item-name">${name}</span>`;
                item.addEventListener('click', () => onClick(name));
                list.appendChild(item);
            });
        }
        catch (err) {
            list.innerHTML = `<div style="padding:20px; color:#e94560; text-align:center;">Failed to list files</div>`;
        }
    });
}
function initFilePicker(viewerInstance) {
    viewer = viewerInstance;
    const tabs = document.querySelectorAll('.fp-tab');
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');
            document.querySelectorAll('.fp-panel').forEach(p => p.classList.remove('active'));
            const panelId = `panel-${tab.dataset.tab}`;
            const panel = document.getElementById(panelId);
            if (panel)
                panel.classList.add('active');
            if (tab.dataset.tab === 'local')
                refreshPickerUi();
        });
    });
    const refreshArchiveButton = document.getElementById('btn-refresh-archive');
    if (refreshArchiveButton) {
        refreshArchiveButton.addEventListener('click', refreshArchive);
    }
    const archiveSearch = document.getElementById('archive-map-search');
    if (archiveSearch) {
        archiveSearch.addEventListener('input', () => {
            window.clearTimeout(archiveSearchTimer);
            archiveSearchTimer = window.setTimeout(refreshArchive, 180);
        });
    }
    const loadLocalButton = document.getElementById('btn-load-local-replay');
    if (loadLocalButton)
        loadLocalButton.addEventListener('click', () => void loadLocalReplays(false));
    const compareLocalButton = document.getElementById('btn-compare-local-replay');
    if (compareLocalButton)
        compareLocalButton.addEventListener('click', () => void loadLocalReplays(true));
    const saveArchiveButton = document.getElementById('btn-save-archive-url');
    if (saveArchiveButton) {
        saveArchiveButton.addEventListener('click', () => saveArchiveUrl(archiveUrl()));
    }
    const chooseCstrikeButton = document.getElementById('btn-choose-cstrike');
    if (chooseCstrikeButton) {
        chooseCstrikeButton.addEventListener('click', chooseCstrikePath);
    }
    const saveCstrikeButton = document.getElementById('btn-save-cstrike');
    if (saveCstrikeButton) {
        saveCstrikeButton.addEventListener('click', () => {
            const input = document.getElementById('cstrike-folder');
            saveCstrikePath((input === null || input === void 0 ? void 0 : input.value) || '');
        });
    }
    const returnBtn = document.getElementById('return-to-replay');
    if (returnBtn) {
        returnBtn.addEventListener('click', hideFilePicker);
    }
    const backBtn = document.getElementById('back-btn');
    if (backBtn) {
        backBtn.addEventListener('click', showFilePicker);
    }
    window.addEventListener('keydown', event => {
        const picker = document.getElementById('file-picker');
        if (event.key === 'Escape' && picker && !picker.classList.contains('hidden') && (viewer === null || viewer === void 0 ? void 0 : viewer.hasLoadedReplay)) {
            event.preventDefault();
            hideFilePicker();
        }
    });
    if (!IS_TAURI) {
        setStatus('Running in browser mode - use the library API to load files');
        return;
    }
    ;
    (() => __awaiter(this, void 0, void 0, function* () {
        try {
            saveCstrikePath(localStorage.getItem('hlviewer.cstrikePath') || '');
            saveArchiveUrl(localStorage.getItem('hlviewer.archiveUrl') || archiveUrl());
            setStatus('');
            if (mapResourceRoot()) {
                yield populateList('map-list', `${mapResourceRoot()}/maps`, ['.bsp'], loadMapByName);
            }
            yield refreshArchive();
        }
        catch (err) {
            console.error('Failed to init file picker:', err);
            setStatus('Failed to load resource directory');
        }
    }))();
}
